import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ButtonComponent } from 'ui-library';

@Component({
    selector: 'app-snackbar',
    templateUrl: "./snackbar.component.html",
    styleUrls: ["./snackbar.component.scss"],
    imports: [
        MatIconModule,
        ButtonComponent,
        CommonModule
    ],
    standalone: true,
})

export class SnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: any,
        private snackBarRef: MatSnackBarRef<SnackbarComponent>
    ) { }

    dismiss() {
        this.snackBarRef.dismiss();
    }
}